import { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer'
import { BrowserRouter } from "react-router-dom";
import PageLayout from './components/PageLayout'
import CssBaseline from '@mui/material/CssBaseline';
import { AppContext } from "./AppContext";
import { PowerBiReport, PowerBiDataset } from './models/models';
import AppOwnsDataWebApi from './services/AppOwnsDataWebApi';

const App = () => {
  const [tenantName, setTenantName] = useState<string>(null);
  const [reports, setReports] = useState<PowerBiReport[]>(null);
  const [datasets, setDatasets] = useState<PowerBiDataset[]>(null);
  const [userName, setUserName] = useState<string>(null);
  const [loginId, setLoginId] = useState<string>(null);
  const [userCanEdit, setUserCanEdit] = useState<boolean>(null);
  const [userCanCreate, setUserCanCreate] = useState<boolean>(null);
  const [workspaceArtifactsLoading, setWorkspaceArtifactsLoading] = useState<boolean>(null);

  let isAuthenticated = Boolean(sessionStorage.getItem("isAuthenticated"));
   
  const onIdle = () => {
     //console.log("In App, the idle time has been exceeded:");
     isAuthenticated = false;
     sessionStorage.clear();
     window.location.replace(AppOwnsDataWebApi.SamlRoot + "InitiateSingleSignOn?returnUrl=" + window.location.href)
  }

  const onAction = () => {
    //console.log("In App, user action has occurred");
  }

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onAction,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
      'focus'
    ],
    timeout: 1000 * 60 * 60,
    throttle: 500
  })

  const refreshEmbeddingData = () => {
      const refreshEmbeddingDataAsync = async () => {
      let viewModel = await AppOwnsDataWebApi.GetEmbeddingData();
      setReports(viewModel.reports);
    };
    refreshEmbeddingDataAsync();
  };

  useEffect(() => {
    const getEmbeddingDataAsync = async () => {
      setWorkspaceArtifactsLoading(true);
      let viewModel = await AppOwnsDataWebApi.GetEmbeddingData();
      setTenantName(viewModel.tenantName);
      setReports(viewModel.reports);
      setDatasets(viewModel.datasets);
      setUserCanEdit(viewModel.userCanEdit);
      setUserCanCreate(viewModel.userCanCreate);
      
      const user = AppOwnsDataWebApi.GetUser();
      setLoginId(user.LoginId);
      setUserName(user.UserName);
      
      setWorkspaceArtifactsLoading(false);
    }
    if (isAuthenticated) {
      getEmbeddingDataAsync()
    };

  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      const interval = setInterval(() => {
        const accessToken = AppOwnsDataWebApi.GetAccessToken();
        if (accessToken === "") {
          //console.log('In App, accessToken is invalid');
          isAuthenticated = false;
          sessionStorage.clear();
          window.location.replace(AppOwnsDataWebApi.SamlRoot + "InitiateSingleSignOn?returnUrl=" + window.location.href)
        } else {
          //console.log('In App, accessToken is valid');
          AppOwnsDataWebApi.GetRenewedJWT();
        }
      }, 5 * 60 * 1000);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      sessionStorage.setItem("loginUserStatus", "0");
      let promise = AppOwnsDataWebApi.GetAuthorization();
      promise.then((token) => {
        if(token != null) {
          let promise = AppOwnsDataWebApi.LoginUser(token);
          promise.then((status) => { 
            sessionStorage.setItem("loginUserStatus", status.toString());
          });
        }
      }).catch((err) => console.log(err));
      console.log("Get LoginUser status: " + sessionStorage.getItem("loginUserStatus"));
    }
  }, []);

  return (
    <AppContext.Provider value={{
      embeddingData: {
        tenantName: tenantName,
        reports: reports,
        datasets: datasets,
        user: userName,
        userCanEdit: userCanEdit,
        userCanCreate: userCanCreate,
        workspaceArtifactsLoading: workspaceArtifactsLoading,
        loginId: loginId
      },
      refreshEmbeddingData: refreshEmbeddingData,
    }}>

    <CssBaseline />
    <BrowserRouter>
    <PageLayout />
    </BrowserRouter>
    </AppContext.Provider>
  )
}

export default App;